import React from 'react'
import './styles.scss'
import { DataElement } from 'components/DataElement'

const colors = [
  '#378EBD',
  '#9BC6DE',
  '#CDE2EE',
  '#D4D4D4',
  '#F4CCCF',
  '#E9999F',
  '#D3343F'
].reverse()
const circleSpace = 21
const svgwidth = 300
const rectwidth = svgwidth / 8

const rectpos = [
  svgwidth / 2 - 3.5 * rectwidth,
  svgwidth / 2 - 2.5 * rectwidth,
  svgwidth / 2 - 1.5 * rectwidth,
  svgwidth / 2 - 0.5 * rectwidth,
  svgwidth / 2 + 0.5 * rectwidth,
  svgwidth / 2 + 1.5 * rectwidth,
  svgwidth / 2 + 2.5 * rectwidth,
  svgwidth / 2 + 3.5 * rectwidth
]
export const DataElementKey = ({
  propNames,
  data,
  locales,
  element
}: {
  element: JSX.Element
  propNames: string[]
  data: any
  locales: (string[] | string)[]
}) => {
  console.log('_____', data)
  return (
    <div className='DataElementKey'>
      <table className='keycontainer' style={{ tableLayout: 'fixed' }}>
        <tbody>
          <tr className='fr'>
            <td className='lc'></td>
            <td className='mc'></td>
            <td className='rc'></td>
          </tr>
          <tr>
            <td colSpan={3} className='first'>
              {propNames[0]}
            </td>
          </tr>
          <tr>
            <td className='ra'>{propNames[1]}</td>
            <td rowSpan={3} className='viz'>
              {element}
            </td>
            <td className='la'>{propNames[4]}</td>
          </tr>
          <tr>
            <td className='ra'>{propNames[2]}</td>
            <td className='la'>{propNames[5]}</td>
          </tr>
          <tr>
            <td className='ra nb'>{propNames[3]}</td>
            <td className='la nb'>{propNames[6]}</td>
          </tr>
          <tr>
            <td className='ra nb bt'>{locales[1]}</td>
            <td className='nb bt np'>
              <svg viewBox={'0 0 ' + svgwidth + ' 60'} width='100%'>
                {colors.map((col, i) => {
                  return (
                    <circle
                    r={12}
                     key={i}
                      cx={rectpos[i]+18.5}
                      cy={28}
                      fill={col}
                    
                    />
                    // <rect
                    // key={i}
                    //   x={rectpos[i]}
                    //   y={16}
                    //   fill={col}
                    //   width={rectwidth - 1}
                    //   height={20}
                    // />
                  )
                })}
                <line
                  x1={svgwidth / 2}
                  x2={svgwidth / 2}
                  y2={90}
                  y1={28}
                  stroke='#7b7768'
                  strokeWidth={2}
                />
              </svg>
            </td>
            <td className='la nb bt'>{locales[0]}</td>
          </tr>
          <tr>
            <td colSpan={3} className='nb pb'>
              {locales[2]}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
